import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { RestrictionItem } from 'src/common/OrderRestrictions/orderRestrictions.utils';
import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { getRestrictionSubheader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/utils/restrictionsSubheader.utils';
import { useMealCreditMerchantRestrictions } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/MerchantRestrictionsRule/hooks/useMealCreditMerchantRestrictions';

export interface UseGetMerchantRestrictionsSubheaderReturn {
  subheader: string;
}

export const useGetMerchantRestrictionsSubheader =
  (): UseGetMerchantRestrictionsSubheaderReturn => {
    const { isLoading, merchantRestrictionsMeta } =
      useMealCreditMerchantRestrictions();
    const { watch } = useFormContext<IMealCreditFormFields>();
    const merchantRestrictionFormSelections = watch('merchantRestrictions');
    let subheader = 'Loading...';

    if (!isLoading) {
      subheader = getRestrictionSubheader({
        restrictions: merchantRestrictionsMeta as RestrictionItem[],
        restrictionFormSelections: merchantRestrictionFormSelections,
      });
    }

    return {
      subheader,
    };
  };
